import { QGetSports } from "./QGetSports";
import { QGetSportsGroupedByDate } from "./QGetSportsGroupedByDate";
import { QGetLeaguesBySportId } from "./QGetLeaguesBySportId";
import { QGetLeaguesByLeagueId } from "./QGetLeaguesByLeagueId";
import { QGetTopLeaguesBySportId } from "./QGetTopLeaguesBySportId";
import { QGetEventsByCouponId } from "./QGetEventsByCouponId";
import { QGetEventsBySportId } from "./QGetEventsBySportId";
import { QGetEventsByEventId } from "./QGetEventsByEventId";
import { QGetEventsByEventIdOrByLeagueId } from "./QGetEventsByEventIdOrByLeagueId";
import { QGetEventsByLeagueId } from "./QGetEventsByLeagueId";
import { QGetEventsFromTopLeaguesBySportId } from "./QGetEventsFromTopLeaguesBySportId";
import { QGetEventsCountByTag } from "./QGetEventsCountByTag";
import { QGetEventsByRegionIdAndSportId } from "./QGetEventsByRegionIdAndSportId";
import { QGetPersonalizedLiveEvents } from "./QGetPersonalizedLiveEvents";
import { QGetPersonalizedPreLiveEvents } from "./QGetPersonalizedPreLiveEvents";
import { QGetEventsByEventIdForBetSlip } from "./QGetEventsByEventIdForBetSlip";
import { QGetPersonalizedSports } from "./QGetPersonalizedSports";
import { QGetMarketsByEventId } from "./QGetMarketsByEventId";
import { QGetGoingLiveEvents } from "./QGetGoingLiveEvents";
export const QueryBuilder = {
    getSports: QGetSports,
    getSportsGroupedByDate: QGetSportsGroupedByDate,
    getLeaguesBySportId: QGetLeaguesBySportId,
    getLeaguesByLeagueId: QGetLeaguesByLeagueId,
    getTopLeaguesBySportId: QGetTopLeaguesBySportId,
    getEventsByCouponId: QGetEventsByCouponId,
    getEventsBySportId: QGetEventsBySportId,
    getEventsByEventId: QGetEventsByEventId,
    getEventsByEventIdOrByLeagueId: QGetEventsByEventIdOrByLeagueId,
    getEventsByLeagueId: QGetEventsByLeagueId,
    getEventsFromTopLeaguesBySportId: QGetEventsFromTopLeaguesBySportId,
    getEventsCountByTag: QGetEventsCountByTag,
    getEventsByRegionIdAndSportId: QGetEventsByRegionIdAndSportId,
    getPersonalizedLiveEvents: QGetPersonalizedLiveEvents,
    getPersonalizedPreLiveEvents: QGetPersonalizedPreLiveEvents,
    getPersonalizedSports: QGetPersonalizedSports,
    getEventsByEventIdForBetSlip: QGetEventsByEventIdForBetSlip,
    getMarketsByEventId: QGetMarketsByEventId,
    getGoingLiveEvents: QGetGoingLiveEvents
};
//# sourceMappingURL=index.js.map